import script from "./AboutUsHospital.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUsHospital.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUsHospital.vue?vue&type=style&index=0&id=72ad7321&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ad7321"]])

export default __exports__